export default "__VITE_ASSET__whVPheO7__"